import formatCurrency from "@utils/formatCurrency"

import styles from "./ItemPrices.module.scss"
import { ItemPricesProps } from "./ItemPrices.types"

export default function ItemPrices(props: ItemPricesProps) {
    const { item, currencyCode, languageCode } = props

    const formattedListPrice = formatCurrency({ value: Number(item.list_price), currencyCode, languageCode })

    // Without a bound customer there is no customer price to compare against, so the
    // list price stands alone and needs no disambiguating label.
    if (item.customer_price === null || item.customer_name === null) {
        return <span className={styles.itemPrice}>{formattedListPrice}</span>
    } else {
        return (
            <div className={styles.priceComparison}>
                <div className={styles.priceEntry}>
                    <span className={styles.priceLabel}>List Price</span>
                    <span className={styles.itemPrice}>{formattedListPrice}</span>
                </div>
                <div className={styles.priceEntry}>
                    <span className={styles.priceLabel}>Your Price ({item.customer_name})</span>
                    <span className={styles.itemPrice}>
                        {formatCurrency({ value: Number(item.customer_price), currencyCode, languageCode })}
                    </span>
                </div>
            </div>
        )
    }
}
